export default {
  settings: {}
}
